import { FichaService } from './../../../ficha-veiculo.service';
import { Component, Input, OnInit } from '@angular/core';
import { cloneDeep } from 'lodash';
import { FichaCadastro } from '../../ficha-cadastro';
import { PendenciaCaminhaoProprio } from '../../model/veiculo';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-ficha-cadastro-detalhe-cliente-caminhao-proprio',
  templateUrl:
    './ficha-cadastro-detalhe-cliente-caminhao-proprio.component.html',
  styleUrls: [
    './ficha-cadastro-detalhe-cliente-caminhao-proprio.component.scss',
  ],
})
export class FichaCadastroDetalheClienteCaminhaoProprioComponent
  implements OnInit {
  @Input() fichaCadastro: FichaCadastro;

  veiculosProprio: PendenciaCaminhaoProprio[];
  veiculosProprioEdited: PendenciaCaminhaoProprio[];

  constructor(private fichaService: FichaService) {}

  ngOnInit() {
    if (
      this.fichaCadastro.veiculoProprioCaminhao &&
      this.fichaCadastro.veiculoProprioCaminhao.length
    ) {
      this.veiculosProprio = this.fichaCadastro.veiculoProprioCaminhao;
      this.refreshVeiculoProprioCaminhaoEdited();
      return;
    }

    this.veiculosProprio = (this.fichaCadastro.veiculoProprio || []).map(
      (veiculosProprio) => ({
        info: veiculosProprio.info || {
          veiculoPlaca: veiculosProprio.placa,
          veiculoAno: veiculosProprio.anoModelo,
          veiculoMarca: veiculosProprio.marca,
          veiculoModelo: veiculosProprio.modelo,
          veiculoVersao: veiculosProprio.versao,
          pendencia: veiculosProprio.status !== 'SUCCESS',
        },
        implemento: veiculosProprio.implemento || {},
        quitado: veiculosProprio.quitado || {},
      })
    );
    this.refreshVeiculoProprioCaminhaoEdited();
  }

  public get isNextAvailable(): boolean {
    return this.veiculosProprioEdited.every(
      (v) =>
        v &&
        v.info &&
        v.info.valid &&
        v.quitado &&
        v.quitado.valid &&
        v.implemento &&
        v.implemento.valid
    );
  }

  private refreshVeiculoProprioCaminhao(): void {
    this.veiculosProprioEdited.map((item, index) => {
      if (!item.info.veiculoMarca) {
        item.info.veiculoMarca = this.veiculosProprio[index].info.veiculoMarca;
      }
    });
    this.fichaCadastro.veiculoProprioCaminhao = this.veiculosProprioEdited;
  }

  private refreshVeiculoProprioCaminhaoEdited(): void {
    this.veiculosProprioEdited = cloneDeep(this.veiculosProprio);
  }

  public onClickPrevious() {
    this.refreshVeiculoProprioCaminhao();
    this.fichaCadastro.onClickPrevious();
  }

  public onClickNext() {
    this.refreshVeiculoProprioCaminhao();
    this.fichaCadastro.onClickNext();
    this.putDataClient();
  }

  private putDataClient() {
    this.fichaService
      .putRecoverFullDataProposal(this.fichaCadastro.recoverData)
      .pipe(take(1))
      .subscribe();
  }

  public changeForm(
    tipo: 'info' | 'quitado' | 'implemento',
    index,
    value
  ): void {
    const valid =
      this.veiculosProprioEdited[index][tipo] &&
      this.veiculosProprioEdited[index][tipo].valid;
    this.veiculosProprioEdited[index][tipo] = { ...value, valid };
  }

  public changeFormValid(
    tipo: 'info' | 'quitado' | 'implemento',
    index,
    value
  ): void {
    if (!this.veiculosProprioEdited[index][tipo]) {
      this.veiculosProprioEdited[index][tipo] = {};
    }
    this.veiculosProprioEdited[index][tipo].valid = value;
  }
}
